import React, {Component, Fragment} from 'react';
import AppConfig from "../../helpers/AppConfig";
import AppUserInformationState from '../../model/AppUserInformationState';
import AppUserService from '../../services/AppUserService';

export default class SidebarElements extends Component<{}, AppUserInformationState> {
    constructor(props: any) {
        super(props);

        this.state = new AppUserInformationState();
    }

    componentDidMount = async() => {
        const appUserInformation = await AppUserService.getAppUserInformation();
        this.setState(appUserInformation);
    }

    render() {
        return (
            <Fragment>
                {/* User Info */}
                {this.state.isAuthenticated &&
                    <div className="user-info d-flex align-items-center justify-content-center">
                        <div className="user-info__img">
                            <a href={AppConfig.PowFormUrl + "/account"} className="user-info__link" title="My Account">
                                {this.state.profilePhoto.length > 0 ? (
                                    <img src={AppConfig.PowFormUrl + this.state.profilePhoto} className="user-info__img-self" alt="User Avatar" />
                                ) : (
                                    <svg className="icon-svg"><use href="#userDefault"></use></svg>
                                )}
                            </a>
                        </div>

                        <div className="user-info__detail">
                            <span className="user-info__name text-crop">{this.state.displayName}</span>
                            <a href={AppConfig.PowFormUrl + "/account"} className="user-info__link" title="My Account">My Account</a>
                        </div>
                    </div>
                }

                {/* Sidebar navigation */}
                <div className="sidebar-nav">
                    <ul className="list-unstyled sidebar-nav__list">
                        <li className="sidebar-nav__item">
                            <a href={AppConfig.PowFormUrl + "/dashboard"} className="sidebar-nav__link" title="Dashboard">
                                <svg className="icon-svg"><use href="#dashboard"></use></svg>
                                <span className="sidebar-nav__text">Dashboard</span>
                            </a>
                        </li>

                        <li className="sidebar-nav__item">
                            <a href={AppConfig.PowFormUrl + "/dashboard/forms"} className="sidebar-nav__link" title="Forms">
                                <svg className="icon-svg"><use href="#forms"></use></svg>
                                <span className="sidebar-nav__text">Forms</span>
                            </a>
                        </li>

                        <li className={`sidebar-nav__item ${this.state.isAuthenticated ? 'sidebar-nav--badge' : ''}`}>
                            <a href={AppConfig.PowFormUrl + "/dashboard/apps"} className="sidebar-nav__link" title="Apps">
                                <svg className="icon-svg"><use href="#apps"></use></svg>
                                <span className="sidebar-nav__text">Apps {this.state.isAuthenticated && <span className="badge badge--default badge--position-rcentered">{this.state.totalApps}</span>}</span>
                            </a>
                        </li>

                        {this.state.isAuthenticated &&
                            <Fragment>
                                <li className="sidebar-nav__item">
                                    <a href={AppConfig.PowFormUrl + "/dashboard/database"} className="sidebar-nav__link sidebar-nav__link--active" title="Database">
                                        <svg className="icon-svg"><use href="#database"></use></svg>
                                        <span className="sidebar-nav__text">Database</span>
                                    </a>
                                </li>

                                <li className="sidebar-nav__item">
                                    <a href={AppConfig.PowFormUrl + "/dashboard/notification-templates"} className="sidebar-nav__link" title="Notifications">
                                        <svg className="icon-svg"><use href="#messaging"></use></svg>
                                        <span className="sidebar-nav__text">Notifications</span>
                                    </a>
                                </li>

                                <li className="sidebar-nav__item">
                                    <a href={AppConfig.PowFormUrl + "/dashboard/report-templates"} className="sidebar-nav__link" title="Reports">
                                        <svg className="icon-svg"><use href="#reporting"></use></svg>
                                        <span className="sidebar-nav__text">Reports</span>
                                    </a>
                                </li>

                                <li className="sidebar-nav__item">
                                    <a href={AppConfig.PowFormUrl + "/logout"} className="sidebar-nav__link" title="Logout" onClick={this.clearSessionStorage}>
                                        <svg className="icon-svg"><use href="#logout"></use></svg>
                                        <span className="sidebar-nav__text">Logout</span>
                                    </a>
                                </li>
                            </Fragment>
                        }
                    </ul>
                </div>
            </Fragment>
        )
    }

    private clearSessionStorage = () => {
        sessionStorage.clear();
    }
}